// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useTenantStore } from "@/providers/TenantContextProvider";
import { useContext } from "react";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
export function useLogsPermissions() {
    var tenantId = useTenantStore()[0];
    var authContext = useContext(AuthContext);
    /**
     * Permissions
     */
    var canReadLogs = authContext.isAuthorized(true, tenantId, IPermissions.LOGS_READ);
    var canExportLogs = authContext.isAuthorized(true, tenantId, IPermissions.LOGS_EXPORT);
    var showLogsColumns = authContext.isAuthorized(true, tenantId, IPermissions.EE_LOGS_COLUMNS);
    var showLogsFilters = authContext.isAuthorized(true, tenantId, IPermissions.EE_LOGS_FILTERS);
    /**
     * Permissions
     */
    return {
        canReadLogs: canReadLogs,
        canExportLogs: canExportLogs,
        showLogsColumns: showLogsColumns,
        showLogsFilters: showLogsFilters,
    };
}
